import { jwtDecode } from "jwt-decode";


export const timeAgo = (serverDate) => {
    const currentDate = new Date();
    const formattedServerTime = new Date(`${serverDate} GMT+0630`).toISOString();
    const date = new Date(formattedServerTime); // Convert to Local Time format
    const diffInSeconds = Math.floor((currentDate.getTime() - date.getTime()) / 1000);
  
    const minutes = Math.floor(diffInSeconds / 60);
    const hours = Math.floor(diffInSeconds / 3600);
    const days = Math.floor(diffInSeconds / 86400);
    const months = Math.floor(days / 30); // Approximation (30 days per month)
    const years = Math.floor(days / 365); // Approximation (365 days per year)

    console.log("dasy", days, months, years)
  
    if (diffInSeconds < 60) return `${diffInSeconds} seconds ago`;
    if (minutes < 60) return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    if (days < 30) return `${days} day${days !== 1 ? "s" : ""} ago`;
    if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
    return `${years} year${years !== 1 ? "s" : ""} ago`;
}

export const addCommaToNumber = (num) => {
    const onlyTwoDecimalNum = num % 1 === 0 ? num : parseFloat(num.toFixed(2));

    return onlyTwoDecimalNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function getPercentage(total, commission) {
    if (total === 0) {
      return 0; 
    }
    return Math.round(((Number(commission) / 100) * Number(total)));
  }

export const getDecoded = () => {
    const token = localStorage.getItem("token");
    const decoded = jwtDecode(token);
    return decoded
}